module.exports = __webpack_public_path__ + "static/media/13. 2024 Verda Attestation of Eligibility From_36450607.51c224ae.pdf";